import { AuthApplication } from '../../model/auth-application';
import { Component } from "@angular/core";
import { AuthApplication_Document } from "../../model/auth-application";
import { ActivatedRoute, Router } from "@angular/router";
import { DialogService } from "projects/Shared-Lib/component/dialog/dialog.service";
import { AppService } from "../../services/app.service";
import { FilterDataService } from "../../services/filter-data.service";
import { DataService } from "projects/Shared-Lib/services/data.service";

@Component({
  selector: 'app-auth-application-edit',
  templateUrl: './auth-application-edit.component.html',
  styleUrls: ['./auth-application-edit.component.css']
})
export class AuthApplicationEditComponent {
  ControllerName = 'AuthApplication';
  Doc: AuthApplication_Document;
  // new or edit
  IsNew: boolean;
  UserId: string;
  Title: string;
  ApplicationID: string;
  selectedItems = [];
  dropdownSettings = {};
  constructor(private route: ActivatedRoute, private dlgService: DialogService,
                private appService: AppService, private filterService: FilterDataService,
                private router: Router, private dataService: DataService) {

    this.Doc = new AuthApplication_Document(dlgService, router, dataService);
    this.Doc.ApplicationID = '';
    this.Doc.SelectEnabled = 1;
  }

  ngOnInit() {
    this.ApplicationID = this.route.snapshot.paramMap.get('id');

    if (this.ApplicationID) {
      //edit mode
      this.Doc.GetDocument(this.ApplicationID);
      this.IsNew = false;
      this.Title = "Edit";
    }
    else {
      //create mode
      this.IsNew = true;
      this.Title = "Create";
    }
  }

  isValid(){
    if (this.Doc.ApplicationID && this.Doc.ApplicationID !== ''
        && this.Doc.AuthCode && this.Doc.AuthCode !== '')
    {
      return false;
    }

    return true;
  }

  Submit(){
    let postData: AuthApplication = new AuthApplication();
    this.Doc.IsEnabled = this.Doc.SelectEnabled === 1;
    postData.SetData(this.Doc);
    if(this.IsNew) {
      this.dataService.addData(this.ControllerName, postData, (ret) => {
          let result = this.dlgService.CreateSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            } 
            else if(ret === 'Create Another') {
              this.Doc.ApplicationID = '';
              this.Doc.AuthCode = '';
              this.Doc.IP = '';
              this.Doc.GrantType = '';
              this.Doc.ReturnUrl = '';
              this.Doc.ErrorReturnUrl = '';
              this.Doc.IsEnabled = false;
              this.Doc.TokenAPI = '';
              this.Doc.PermissionAPI = '';
              this.Doc.SelectEnabled = 1;
            }
          }).catch((error) => {
            console.error(error);
          });
      }, (ret) =>{
        let result = this.dlgService.ErrorInformation(ret.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    else{
      this.dataService.updateData(`${this.ControllerName}/${this.Doc.ApplicationID}`, postData, (ret) => {
          let result = this.dlgService.EditSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            }
          }).catch((error) => {
            console.error(error);
          });
      }, (ret) =>{
        let result = this.dlgService.ErrorInformation(ret.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Auth/AuthApplication']);
  }

}